'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' });

var Payment = function Payment(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Payment = (0, _pure2.default)(Payment);
Payment.muiName = 'SvgIcon';

exports.default = Payment;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Payment.js
// module id = 2676
// module chunks = 0